<template>
  <div>
    <div class="banner">
        <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
     <v-row dense>
        <v-col class="d-flex" cols="12" sm="12">
            <v-select 
            :items="types_orgons"
            item-text="description"
            item-value="id"
            class="rounded-lg" 
            color="#41916b"
            outlined  
            v-model="resource.type_orgon_id" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Tipo de Orgão<span style="color: red;">*</span>
                </template>
            </v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
            <v-text-field 
            class="rounded-lg" 
            color="#41916b"
            outlined 
            maxlength="50"
            counter="50"
            v-model="resource.name" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Nome do Orgão/Tecido <span style="color: red;">*</span>
                </template>
            </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
            <v-autocomplete
            :items="unities"
            item-text="hospital"
            item-value="id"
            class="rounded-lg" 
            color="#41916b"
            outlined  
            multiple
            v-model="resource.link_unities" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Unidades Transplantadoras<span style="color: red;">*</span>
                </template>
            </v-autocomplete>
        </v-col>
     </v-row> 
     <v-card-actions class="d-flex justify-end">
        <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
            <span>{{$t('buttons.cancel')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
            <span>{{$t('buttons.clean_up')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
            <span class="textBtn">{{ btnMessage }}</span>
            <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
    </v-card-actions>
    </v-form> 
  </div>
</template>
<script>
import { getTypeOrgons, getTransplanterUnities, saveOrgon } from "@/service/basic-registrations/OrgonsTissuesService";
import Formatters from "@/utils/Formatters";
import { mapActions } from "vuex";

export default {
  data() {
    return {
        dialog: false,
        formRules: [(v) => !!v || "Campo obrigatório."],
        loading: false,
        types_orgons: [],
        unities: []
      };
  },

  props: {
      resource: {
        type: Object,
      }
    },

  computed: {
    title() {
      return this.resource.id ? 'Atualizar Órgão/Tecido' : 'Novo Órgão/Tecido';
    },

    btnMessage() {
      return this.resource.id ? 'Atualizar' : 'Salvar';
    }
  },

  watch: {
    'resource': {
      handler(item) {
        this.resource.type_orgon_id = parseInt(item.type_orgon_id)
        this.resource.link_unities = this.resource.orgon_unities.map(item => Number(item.unity_id))

        if (!item.id && this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },

      immediate: true
    }
  },

  mounted(){
    getTypeOrgons().then((result) => {
      this.types_orgons = result;
    });
    getTransplanterUnities().then((result) => {
      this.unities = result;
    });
  },

  methods: {
    ...mapActions([
        "changeSnackBarData"
    ]),

    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {

        let data = {
            name: this.resource.name,
            link_unities: this.resource.link_unities,
            type_orgon_id: this.resource.type_orgon_id
        }
            saveOrgon(this.resource.id || null, data).then((response) => {
            this.loading = false; 
             
            this.changeSnackBarData({
              status: true,
              type: 'success', 
              titleMessage: response.data.message,
              bodyMessage: '',
              cardColor: 'success',
              titleIcon: 'mdi-check-circle',
            }); 

            setTimeout(() => { 
               this.closeSnackBar();
               this.closeDialog();
            }, 3000);
 
          }).catch((err) => {
            this.loading = false;
             this.changeSnackBarData({
                status: true,
                type: 'erro', 
                titleMessage: this.$t('messages.something_went_wrong'),
                bodyMessage: Formatters.formatErrorMessage(err),
                cardColor: 'red',
                titleIcon: 'mdi-close-circle',
            });

            setTimeout(() => {
              this.closeSnackBar(); 
            }, 3000);
          });   
      }
    },

    closeDialog() {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
        this.$emit("closeDialog");
    },

    closeSnackBar(){
        this.changeSnackBarData({
            status: false,
            type: '', 
            titleMessage: '',
            bodyMessage: '',
            cardColor: '',
            titleIcon: '',
        });
    } 
  }, 
};
</script>
<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
  